module.exports = __webpack_public_path__ + "ptc_nakagawa_W2.3991ef82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_W2.jpg
// module id = Jj2X
// module chunks = 0